import React, { createContext, useContext, useState, useEffect, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
var StoreStatusContext = /*#__PURE__*/createContext(null);
var STORE_STATUS_QUERY = "\n  query {\n    setting {\n      storeStatus\n      deliveryEnabled\n    }\n  }\n";
export function StoreStatusProvider(_ref) {
  var {
    children
  } = _ref;
  var [storeStatus, setStoreStatus] = useState(null);
  var [deliveryEnabled, setDeliveryEnabled] = useState(null);
  var [loading, setLoading] = useState(true);
  var fetchStoreStatus = useCallback(async () => {
    try {
      var _result$data, _result$data2;
      var response = await fetch('/api/graphql', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          query: STORE_STATUS_QUERY
        })
      });
      var result = await response.json();
      if ((result === null || result === void 0 || (_result$data = result.data) === null || _result$data === void 0 || (_result$data = _result$data.setting) === null || _result$data === void 0 ? void 0 : _result$data.storeStatus) !== undefined) {
        setStoreStatus(result.data.setting.storeStatus);
      } else {
        setStoreStatus('1');
      }
      if ((result === null || result === void 0 || (_result$data2 = result.data) === null || _result$data2 === void 0 || (_result$data2 = _result$data2.setting) === null || _result$data2 === void 0 ? void 0 : _result$data2.deliveryEnabled) !== undefined) {
        setDeliveryEnabled(result.data.setting.deliveryEnabled);
      } else {
        setDeliveryEnabled('1');
      }
    } catch (_unused) {
      setStoreStatus('1');
      setDeliveryEnabled('1');
    } finally {
      setLoading(false);
    }
  }, []);
  useEffect(() => {
    fetchStoreStatus();
    var interval = setInterval(fetchStoreStatus, 30000);
    var handleStorage = e => {
      if (e.key === 'storeSettingsUpdatedAt') {
        fetchStoreStatus();
      }
    };
    window.addEventListener('storage', handleStorage);
    return () => {
      clearInterval(interval);
      window.removeEventListener('storage', handleStorage);
    };
  }, [fetchStoreStatus]);
  var isStoreEnabled = storeStatus === '1' || storeStatus === 1 || storeStatus === true;
  var isDeliveryEnabled = deliveryEnabled === '1' || deliveryEnabled === 1 || deliveryEnabled === true;
  var contextValue = useMemo(() => ({
    storeStatus,
    isStoreEnabled,
    deliveryEnabled,
    isDeliveryEnabled,
    loading,
    refetch: fetchStoreStatus
  }), [storeStatus, isStoreEnabled, deliveryEnabled, isDeliveryEnabled, loading, fetchStoreStatus]);
  return /*#__PURE__*/React.createElement(StoreStatusContext.Provider, {
    value: contextValue
  }, children);
}
StoreStatusProvider.propTypes = {
  children: PropTypes.node.isRequired
};
export function useStoreStatus() {
  var context = useContext(StoreStatusContext);
  if (!context) {
    throw new Error('useStoreStatus must be used within a StoreStatusProvider');
  }
  return context;
}
export default StoreStatusContext;